import { render, staticRenderFns } from "./AccountLogisticsList.vue?vue&type=template&id=29ffce20&"
import script from "./AccountLogisticsList.vue?vue&type=script&lang=js&"
export * from "./AccountLogisticsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports